import {
  CHANGE_PASSWORD_FAILURE,
  CHANGE_PASSWORD_REQUEST,
  CHANGE_PASSWORD_SUCCESS,
  CHANGE_EMAIL_FAILURE,
  CHANGE_EMAIL_REQUEST,
  CHANGE_EMAIL_SUCCESS,
  CONFIRM_RESET_PASSWORD_FAILURE,
  CONFIRM_RESET_PASSWORD_REQUEST,
  CONFIRM_RESET_PASSWORD_SUCCESS,
  LOGIN_REQUEST,
  LOGIN_FAILURE,
  LOGIN_LOGOUT,
  LOGIN_SUCCESS,
  LOGIN_SUCCESS_OTP,
  RESET_PASSWORD_FAILURE,
  RESET_PASSWORD_REQUEST,
  RESET_PASSWORD_SUCCESS,
} from '../constants/actionTypes';
import { extractErrorMessage } from '../utils/extractErrorMessage';

const initialState = {
  username: localStorage.getItem('username'),
  token: localStorage.getItem('token'),
  isLoggedIn: !!localStorage.getItem('token'),
  offlineOnly: localStorage.getItem('offlineOnly'),
  error: null,
  message: null,
  isLoading: false,
};

export default function(state = initialState, action) {
  switch (action.type) {
    case LOGIN_REQUEST:
      return{
        ...state,
        isLoading: true
      }
    case LOGIN_SUCCESS:
      return {
        username: action.username,
        token: action.token,
        isLoggedIn: true,
        offlineOnly: action.offlineOnly,
        error: false,
        otpNeeded: false,
        message: null,
        isLoading: false
      };
    case LOGIN_SUCCESS_OTP:
      localStorage.setItem('username', action.username);
      return {
        username: action.username,
        token: null,
        isLoggedIn: false,
        error: false,
        otpNeeded: true,
        message: action.message
      };
    case LOGIN_FAILURE:
      return {
        username: null,
        token: null,
        isLoggedIn: false,
        otpNeeded: false,
        message: null,
        error: extractErrorMessage(action.error),
        isLoading: false
      };
    case LOGIN_LOGOUT:
      localStorage.removeItem('token');
      return {
        username: null,
        token: null,
        isLoggedIn: false,
        otpNeeded: false,
        error: null,
        message: null,
        isLoading: false
      };
    case CHANGE_PASSWORD_REQUEST:
    case RESET_PASSWORD_REQUEST:
    case CONFIRM_RESET_PASSWORD_REQUEST:
      return {
        ...state, 
        error: null, 
        isLoading: true
      };
    case RESET_PASSWORD_FAILURE:
      return {...state, 
        error: action.error, 
        isLoading: false
      };
    case CHANGE_PASSWORD_FAILURE:
    case CONFIRM_RESET_PASSWORD_FAILURE:
      return {...state, 
        error: extractErrorMessage(action.error), 
        isLoading: false
      };
    case CHANGE_PASSWORD_SUCCESS:
    case RESET_PASSWORD_SUCCESS:
    case CONFIRM_RESET_PASSWORD_SUCCESS:
      return {
        ...state, 
        error: false,
        isLoading: false
      };
    case CHANGE_EMAIL_REQUEST:
    case CHANGE_EMAIL_SUCCESS:
    case CHANGE_EMAIL_FAILURE:
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./node_modules/source-map-loader!./src/reducers/authState.js